import RoleTemplatePortalRoleLnkHashTableTypes from "../types/hashTableTypes/RoleTemplatePortalRoleLnkHashTableTypes"
import ratmHash from "./RATMHash"

const { lookupHashTableItem } = ratmHash

const generateClassNames = (roleId: number, prefix: string, key1: string, key2: string, key3: string, disabled: boolean) => {
    const linkedFromHash: RoleTemplatePortalRoleLnkHashTableTypes = lookupHashTableItem(roleId, 2)
    let cName = ""
    if (linkedFromHash && !disabled) {
        const permissions = linkedFromHash[2].permissions
        //@ts-ignore
        if (permissions[key2] && !permissions[key1]) {
            cName += `${prefix}${key2.charAt(0).toUpperCase() + key2.slice(1)}`
            //@ts-ignore
        } else if (permissions[key3] && permissions[key1]) {
            cName += `${prefix}${key3.charAt(0).toUpperCase() + key3.slice(1)}`
        }
    }
    return cName
}

export default generateClassNames

